<script>
import {useMenuStore} from "@js/store/MenuStore";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconCart from "@js/components/Icons/IconCart.vue";
import {Link} from "@inertiajs/vue3";
import {useCartStore} from "@js/store/CartStore.js";
import IconBag from "@js/components/Icons/IconBag.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";

export default {
    name: "MobileNav",
    components: {IconWhatsApp, IconBag, IconCart, IconPhone, Link},
    setup() {
        const menuStore = useMenuStore()
        const callbackStore = useCallbackFormsStore()
        const cartStore = useCartStore()

        return {menuStore, callbackStore, cartStore}
    }
};
</script>

<template>
    <div
        class="fixed z-10 w-[95%] h-16 max-w-lg left-0 right-0 m-auto bg-white border border-gray-300 rounded-full bottom-4 transform animate-slide-up overflow-hidden shadow">
        <div class="grid h-full max-w-lg grid-cols-5 mx-auto">
            <a href="tel:+79014170477" aria-label="Вызов" title="Вызов"
               class="inline-flex flex-col items-center justify-center px-5 rounded-s-full hover:bg-gray-50 group">
                <IconPhone class="w-8 h-8 mb-1 text-gray-500"/>
            </a>
            <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
               aria-label="WhatsApp" title="WhatsApp" target="_blank"
               class="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 group">
                <IconWhatsApp class="w-7 h-7 mb-1 text-gray-500"/>
            </a>
            <div class="flex items-center justify-center">
                <button type="button" @click="menuStore.toggleSidenav" aria-label="Меню" title="Меню"
                        class="inline-flex items-center justify-center w-10 h-10 font-medium bg-indigo-600 rounded-full hover:bg-indigo-700 group focus:outline-none">
                    <img class="w-4 h-4" alt="Меню" title="Меню"
                         src="@img/mobile-nav/menu.png">
                </button>
            </div>
            <Link :href="route('catalog')" aria-label="Каталог" title="Каталог"
                  class="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 group">
                <IconBag class="w-7 h-7 mb-1 text-gray-500"/>
            </Link>
            <Link :href="route('cart')" aria-label="Корзина" title="Корзина"
                  class="relative inline-flex flex-col items-center justify-center px-5 rounded-e-full hover:bg-gray-50 group">
                <IconCart class="w-7 h-7 mb-1 text-gray-500"/>
                <div v-if="cartStore.cart.length > 0"
                     class="absolute text-[7px] font-bold flex items-center justify-center w-4 h-4 bg-indigo-600/90 rounded-full mb-5 ms-5 text-white">
                    {{ cartStore.cart.length }}
                </div>
            </Link>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
